// extracted by mini-css-extract-plugin
export default {"actors-button-wrapper":"DoctorCommissionProgramActors_actors-button-wrapper__O7dlE"};